import React, { createContext, useContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import cookieService from './CookieService';

const GlobalContext = createContext();

export const useGlobal = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error('useGlobal must be used within a GlobalProvider');
  }
  return context;
};

export const GlobalProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tourStartRequested, setTourStartRequested] = useState(false);
  const [tourGuideType, setTourGuideType] = useState(null); // null = default guide per route
  const [tourResumeStep, setTourResumeStep] = useState(0);  // step index to resume from on next page

  useEffect(() => {
    const initializeUser = () => {
      try {
        const token = cookieService.getToken();
        if (token) {
          const decoded = jwtDecode(token);
          // Handle both 'role' (new format) and 'roles' (old format)
          let userRole = null;
          if (decoded.role) {
            userRole = decoded.role.replace(/^ROLE_/, "");
          } else if (decoded.roles && decoded.roles.length > 0) {
            userRole = decoded.roles[0].replace(/^ROLE_/, "");
          }
          
          setUser({
            id: decoded.sub,
            username: decoded.sub,
            role: userRole || (decoded.roles && decoded.roles[0]) || null,
            email: decoded.email || '',
            permissions: decoded.permissions || []
          });
        }
      } catch (error) {
        console.error('GlobalContext: Error initializing user:', error);
        // Don't remove token on decode error - let AuthProvider handle it
        // Only clear user state, not the token
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    initializeUser();
  }, []);

  const updateUser = (userData) => {
    setUser(userData);
  };

  const clearUser = () => {
    setUser(null);
    cookieService.removeToken();
  };

  const value = {
    user,
    loading,
    updateUser,
    clearUser,
    tourStartRequested,
    setTourStartRequested,
    tourGuideType,
    setTourGuideType,
    tourResumeStep,
    setTourResumeStep
  };

  return (
    <GlobalContext.Provider value={value}>
      {children}
    </GlobalContext.Provider>
  );
};
